import React, { useState } from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import { isMobileOnly } from 'react-device-detect';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import SubmitDetails from './submit-details.png';
import SelectOption from './option.png';
import Customize from './customize.png';
import Estimation from './review.png';

import './howitworks.scss';

import { CarousalItem } from './CarousalItem';

function HowItWorks() {
  const [index, setIndex] = useState(0);
  const [sliderInstance, setSliderInstance] = useState({});

  const sliderSettings = {
    arrows: false,
    initialSlide: index,
    fade: true,
    beforeChange: (current, next) => setIndex(next),
  };

  const handleSelect = selectedIndex => {
    setIndex(selectedIndex);
    sliderInstance.slickGoTo(selectedIndex);
  };

  return (
    <div className="how-it-works">
      <div className="container">
        <h2>How It Works</h2>
        <div className="carousel-container">
          <Slider {...sliderSettings} ref={slider => setSliderInstance(slider)}>
            <CarousalItem
              img={{
                src: SubmitDetails,
                alt: 'First slide',
              }}
              content="Tell us how you’d like to use your rooms, the size of your space and whether you
                    need a kitchen or not"
              title="Submit Detail"
            />

            <CarousalItem
              img={{
                src: SelectOption,
                alt: 'Second slide',
              }}
              content="We’ve already done the hard work for you & curated options that give you a head
                      start in getting to your final cost estimate. Just choose an option that works
                      best for you & customize, if needed"
              title="Select An Option"
            />

            <CarousalItem
              img={{
                src: Customize,
                alt: 'Third slide',
              }}
              content="Add, edit or delete items as per your requirements. View labor & material costs
                      & quantities at the item or project level. Review assumptions, material
                      specifications & understand what is not included in the cost estimate"
              title="Customize & Review"
            />

            <CarousalItem
              img={{
                src: Estimation,
                alt: 'Fourth slide',
              }}
              content="As updates are made, costs & time-lines will change in real-time. Once done, get
                      your final cost estimate & schedule for the project. Call us for a Free Design
                      Consultation!"
              title="Get Estimates & Time-lines"
            />
          </Slider>
          {!isMobileOnly && (
            <div className="bottom-indicators">
              <ul>
                <li
                  onClick={() => handleSelect(0)}
                  className={classNames('item', index === 0 ? 'active' : '')}
                >
                  <span>1</span>
                  Submit detail
                </li>
                <li
                  onClick={() => handleSelect(1)}
                  className={classNames('item', index === 1 ? 'active' : '')}
                >
                  <span>2</span>
                  Select Option
                </li>
                <li
                  onClick={() => handleSelect(2)}
                  className={classNames('item', index === 2 ? 'active' : '')}
                >
                  <span>3</span>
                  Customize
                </li>
                <li
                  onClick={() => handleSelect(3)}
                  className={classNames('item', index === 3 ? 'active' : '')}
                >
                  <span>4</span>
                  Estimation
                </li>
              </ul>
            </div>
          )}

          {isMobileOnly && (
            <div className="slider-indicators tw-flex tw-justify-center">
              {[0, 1, 2, 3].map(number => (
                <button
                  type="button"
                  className={`tw-bg-white tw-border-cta tw-border tw-rounded tw-w-16 tw-h-2 tw-m-2 ${
                    index === number ? 'tw-bg-cta' : ''
                  }`}
                  onClick={() => handleSelect(number)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export { HowItWorks };
